import { DOTHelper } from 'lib/dot/DOTHelper.ts';
import type { SearchType } from 'lib/dot/enum/searchType.ts';
import type { TSortBySort } from 'utils/constants.ts';

export type SortOffersAnalytics = {
	action: 'sortResults';
	itemCount?: number;
	searchType: SearchType;
	type: SortAnalytics;
};

export type SortAnalytics = 'newest' | 'lowestValue' | 'highestValue';

export function sendSortOffersAnalytics(type: SortAnalytics, itemCount?: number) {
	const store = DOTHelper.getStore();

	const data: SortOffersAnalytics = {
		action: 'sortResults',
		itemCount,
		searchType: store.searchType,
		type,
	};

	return DOTHelper.hit(data);
}

export function sortToSortAnalytics(sort: TSortBySort | 'priceDesc' | 'priceAsc'): SortAnalytics {
	switch (sort) {
		case '-create_date':
			return 'newest';
		case '-price':
		case 'priceDesc':
			return 'highestValue';
		case 'price':
		case 'priceAsc':
			return 'lowestValue';
		default:
			return 'newest';
	}
}
